import { ColorCardGrid as ColorCardGridNPM } from '@rotaryintl/component-color-card-grid';
import { Placeholder, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import React from 'react';

const ColorCardGrid = ({ rendering, params: { ComponentId } = {} }) => (
  <ColorCardGridNPM id={ComponentId}>
    <Placeholder rendering={rendering} name="colorcard-grid" />
  </ColorCardGridNPM>
);

export default withSitecoreContext()(ColorCardGrid);
